var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 105H95C100.523 105 105 100.523 105 95V25C105 19.4772 100.523 15 95 15H25C19.4772 15 15 19.4772 15 25V95C15 100.523 19.4772 105 25 105ZM25 105L80 50L105 75M50 42.5C50 46.6421 46.6421 50 42.5 50C38.3579 50 35 46.6421 35 42.5C35 38.3579 38.3579 35 42.5 35C46.6421 35 50 38.3579 50 42.5Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.2,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.b3662b7d4fdf50d74a24503a2b291c79.svg";
export { ForwardRef as ReactComponent };